import type {
  CampoDeDatoDeConstruccion,
  NotasDeUnaConstruccion,
  RegistroDeTerrenoDelInforme,
} from "@/lib/terreno";

/* ---------------------------------------------------------------------------
   Las notas por dato de una construcción: lo que el encargado anotó en terreno
   sobre Tipo, Año, Superficie o Clase ("los registros dicen 100 m², en terreno
   son 50"). Es una PROPUESTA para quien redacta; acá solo se lee y se reparte.
--------------------------------------------------------------------------- */

export const CAMPOS_DE_CONSTRUCCION: CampoDeDatoDeConstruccion[] = [
  "tipo",
  "anio",
  "superficie",
  "clase",
];

// Son los rótulos que `VistaDelRegistroDeTerreno` pone en `datos`; si el API
// los cambia, la tarjeta de terreno deja de poder ubicar la nota junto a su dato.
const ETIQUETAS: Record<CampoDeDatoDeConstruccion, string> = {
  tipo: "Tipo",
  anio: "Año",
  superficie: "Superficie",
  clase: "Clase",
};

export function etiquetaDelCampoDeConstruccion(campo: CampoDeDatoDeConstruccion): string {
  return ETIQUETAS[campo];
}

/** El campo al que pertenece un rótulo de `datos`, o `null` si no admite nota. */
export function campoDeLaEtiqueta(etiqueta: string): CampoDeDatoDeConstruccion | null {
  return CAMPOS_DE_CONSTRUCCION.find((c) => ETIQUETAS[c] === etiqueta) ?? null;
}

/**
 * Las notas de cada construcción de la tabla web, por id de fila.
 *
 * Solo `web:<id>`: una `terreno:<uuid>` no es una fila del cuadro, y su nota se
 * ve únicamente en la pestaña de terreno.
 */
export function notasDeConstruccionesWeb(
  registro: RegistroDeTerrenoDelInforme | undefined,
): Record<number, NotasDeUnaConstruccion> {
  const mapa: Record<number, NotasDeUnaConstruccion> = {};
  const seccion = registro?.secciones.find((s) => s.clave === "construcciones");

  for (const item of seccion?.items ?? []) {
    const id = /^web:(\d+)$/.exec(item.referencia)?.[1];

    if (id === undefined || !item.notas || Object.keys(item.notas).length === 0) continue;

    mapa[Number(id)] = item.notas;
  }

  return mapa;
}
